import { takeLatest, put, call } from 'redux-saga/effects';

// -------

import axios from 'app/services/http/axios';
import {Actions} from './slice';
import { objectToUrl } from 'app/services/helpers'

import { Api } from 'modules/Admin/Companies'

// -------

function* getList({payload: {pageNumber, filters}}) {

  try {
    let route = Api.companies;
    route += objectToUrl({
      ...filters,
      page: pageNumber
    }, true)

    const response = yield call(axios.get, route);
    yield put(Actions.getListSuccess(response));

  } catch (e) {
    return yield put(Actions.getListFailed(e));
  }
}

// ------- ACTIONS

function* toDelete({payload: {id}}) {
  try {
    let route = `${Api.companies}/${id}`;
    const response = yield call(axios.delete, route);
    yield put(Actions.toDeleteSuccess(response));
  } catch (e) {
    return yield put(Actions.toDeleteFailed(e));
  }
}

// -------

export function* watchCompaniesListSaga() {
  yield takeLatest(Actions.getList.type, getList)
  yield takeLatest(Actions.toDelete.type, toDelete)
}

export default watchCompaniesListSaga

